import { render, staticRenderFns } from "./DensityChart.vue?vue&type=template&id=8db9f48e&scoped=true"
import script from "./DensityChart.vue?vue&type=script&lang=js"
export * from "./DensityChart.vue?vue&type=script&lang=js"
import style0 from "./DensityChart.vue?vue&type=style&index=0&id=8db9f48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db9f48e",
  null
  
)

export default component.exports